export const Error = ({ size = "14" }: { size?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 15 14"
      fill="none"
    >
      <g clipPath="url(#clip0_2492_404)">
        <path
          d="M13.9873 3.58808L10.9119 0.512167C10.5812 0.182 10.1413 0 9.67467 0H5.32592C4.85925 0 4.41942 0.182 4.08808 0.51275L1.01275 3.58808C0.682583 3.91883 0.5 4.35808 0.5 4.82533V9.17467C0.5 9.64192 0.682 10.0812 1.01275 10.4119L4.08808 13.4878C4.41883 13.818 4.85867 14 5.32533 14H9.67408C10.1408 14 10.5806 13.818 10.9119 13.4872L13.9867 10.4119C14.3168 10.0812 14.4994 9.64192 14.4994 9.17467V4.82533C14.4994 4.35808 14.3174 3.91883 13.9873 3.58808ZM6.91667 3.5H8.08333V7.58333H6.91667V3.5ZM7.5 10.5C7.017 10.5 6.625 10.108 6.625 9.625C6.625 9.142 7.017 8.75 7.5 8.75C7.983 8.75 8.375 9.142 8.375 9.625C8.375 10.108 7.983 10.5 7.5 10.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2492_404">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
